import React,{useEffect, useState} from "react"

import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Link, Redirect, useNavigate } from 'react-router-dom';
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "./../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import Switch from "react-switch"
import { Chrono } from "react-chrono";
import { BarLoader } from "react-spinners";

const Operations = (props) => {
  document.title = "Opérations | Interface des opérations";

  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Tables", link: "#" },
    { title: "Responsive Table", link: "#" },
  ]
  const [loadingOps, setLoadingOps] = useState(false);
  const [opUpdate, setOpUpdate] = useState("");
  const [agences, setAgences] = useState([]);
  const [dest, setDest] = useState('');
  const [dep, setDep] = useState('');
  const [agDest, setAgDest] = useState('');
  const [selectedDep, setSelectedDep] = useState(null);
  const [selectedDest, setSelectedDest] = useState(null);
  const [selectedNewDest, setSelectedNewDest] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedTypeRetrait, setSelectedTypeRetrait] = useState(null);
  const [newDest, setNewDest] = useState(null);
  const [selectedAgDest, setSelectedAgDest] = useState(null);
  const [emballage, setEmballage] = useState(null);
  const [operations, setOperations] = useState([]);
  const [emballages, setEmballages] = useState([]);
  const [allEcoms, setAllEcoms] = useState([]);
  const [ecoms, setEcoms] = useState([]);
  const [ecom, setEcom] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [status, setStatus] = useState("");
  const [selectEcom, setSelectEcom] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [natures, setNatures] = useState([]);
  const [totalOps, setTotalOps] = useState(0);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const optionGroup = [ { options: agences } ]
  const [searchNat, setSearchNat] = useState("");
  const optionEmballages = [ { options: emballages } ]
  const optionEcom = [ { options: ecoms } ]
  const optionStatus = [ { options: [{label: "Tout", value: ""},{label: "En attente", value: 1}, {label: "Expédié", value: 2}, {label: "Arrivé à destination", value: 3}, {label: "Livré", value: 4}] } ]
  const optionType = [ { options: [{label: "Tout", value: ""}, {label: "STANDARD", value: "DEFAULT"}, {label: "E-COMMERCE", value: "ECOM"}, {label: "CLIENT EN COMPTE", value: "COMPTE"}, {label: "SAINT VALENTIN", value: "SAINT VALENTIN"}, {label: "RAMADAN", value: "RAMADAN"}, {label: "PACQUES", value: "PACQUES"}] } ]
  const optionTypeRetrait = [ { options: [{label: "Tout", value: ""}, {label: "AVEC CARTE", value: 0}, {label: "SANS CARTE", value: 1}] } ]
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const handleDepart= (event)=>{ setSelectedDep(event); setDep(event.value); }
  const handleNewDestination= (event)=>{ setSelectedNewDest(event); setNewDest(event.value); }
  const handleAgDestination= (event)=>{ setSelectedAgDest(event); setAgDest(event.value); }
  const handleEcom= (event)=>{ setSelectEcom(event); setEcom(event.value); 
    const result = allEcoms.find(item => item.ecomId === event.value);
    setExp(result.ecomNom); setPhoneExp(result.ecomPhone);
  }
  const handleStatus= (event)=>{ setSelectedStatus(event); setStatus(event.value); }
  const handleType= (event)=>{ setSelectedType(event); }
  const handleTypeRetrait= (event)=>{ setSelectedTypeRetrait(event); }
  const [detail, setDetail] = useState(null);
  const [phoneExp, setPhoneExp] = useState("")
  const [frais, setFrais] = useState("")
  const [valeur, setValeur] = useState("")
  const [exp, setExp] = useState("")
  const [benef, setBenef] = useState("")
  const [phoneDest, setPhoneDest] = useState("")
  const [modal_set_opera, setmodal_set_opera] = useState(false)
  const [modal_del_opera, setmodal_del_opera] = useState(false)
  const [modal_change_dest, setmodal_change_dest] = useState(false)
  const [modal_opera, setmodal_opera] = useState(false)
  const [smsActive, setSmsActive] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null); 
  const userJson= JSON.parse(localStorage.getItem("user"));
  const [msgError, setMsgError]= useState("")
  const [msgSuccess, setMsgSuccess]= useState("")
  const [readOnly, setReadOnly]= useState(false)
  const [displayEcom, setDisplayEcom]= useState("none")
  const [displayExp, setDisplayExp]= useState("block")
  const [numColis, setNumColis]= useState("")
  const [numExp, setNumExp]= useState("")
  const [numBenef, setNumBenef]= useState("")
  const navigate = useNavigate();
  const Offsymbol = (props) => {
    return (
      <div
        style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}>
        {" "} NON
      </div>
    )
  }
  
  const handleClick = (key) => {
    setSelectedRow(key); 
  };

  const OnSymbol = () => {
    return (
      <div
        style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}>
        {" "} OUI
      </div>
    )
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_set_opera() { setmodal_set_opera(!modal_set_opera); removeBodyCss()}
  function tog_get_opera() { setmodal_opera(!modal_opera); removeBodyCss() }
  function tog_del_opera() { setmodal_del_opera(!modal_del_opera); removeBodyCss() }
  function tog_change_dest() { setmodal_change_dest(!modal_change_dest); removeBodyCss() }

  const loadAgences= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let agencesArray= [{label: "Toutes les agences", value: ''}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))]; 
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const updateOperationPrice=()=>{
    if (verifData()) {
      fetch(url.BACKEND_URL+"/operation/cost-price/"+detail?.opId+"?valeur="+valeur+"&frais="+frais, {
        method: 'PUT', headers: {'Accept': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          setOperations(prevOperations => 
            prevOperations.map(op => 
              op.opId === detail?.opId ? { ...op, opValeur: valeur, opFrais: frais } : op )
          );
          setMsgSuccess(responseJson.message)
          setTimeout(() => { tog_set_opera(); setMsgSuccess(""); }, 350);
      } else {  }
      }) .catch((error) => {  });
    }
  }
  
  const changeDestination=()=>{
    if (verifDataDest()) {
      fetch(url.BACKEND_URL+"/operation/change-destination?id="+detail?.opId+"&dest="+newDest, {
        method: 'PUT', headers: {'Accept': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          setOperations(prevOperations =>
            prevOperations.map(op => 
              op.opId === detail?.opId ? { ...op, opAgdest: responseJson.data.opAgdest } : op )
          );
          setMsgSuccess(responseJson.message)
          setTimeout(() => { tog_change_dest(); setMsgSuccess(""); }, 350);
      } else {  }
      }) .catch((error) => {  });
    }
  }
  
  const deleteOperation=()=>{
      fetch(url.BACKEND_URL+"/operation/"+detail?.opId, {
        method: 'DELETE', headers: {'Accept': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          setOperations(prevOperations => 
            prevOperations.filter(op=>op.opId!==detail?.opId)
          );
          setMsgSuccess(responseJson.message)
          setTimeout(() => { tog_del_opera(); setMsgSuccess(""); }, 350);
      } else {  }
      }) .catch((error) => {  });
  }

  const loadOperations=(page)=> { 
    setLoadingOps(true)
    fetch(`${url.BACKEND_URL}/operation?start=${startDate}&end=${endDate}&page=${page}&size=30&etp=${userJson.usAgence.agEtp.etpId}&agexp=${dep}&agdest=${dest}&stat=${status}&code=${numColis}&type=${selectedType ? selectedType?.value : ""}&withIdCard=${selectedTypeRetrait ? selectedTypeRetrait?.value : ""}&phonexp=${numExp}&phonedest=${numBenef}`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setOperations(responseJson.data)
        setTotalOps(responseJson.totalElement)
        setTotalPage(responseJson.totalPage, 30)
        setCurrPage(responseJson.current_page, 30)
        setLoadingOps(false)
    } else { setOperations([]); setTotalOps(0); setTotalPage(0); setCurrPage(0); setLoadingOps(false)  }
    }) .catch((error) => {  setLoadingOps(false) });
  };

  const getOperation=(item)=> {
    let timeLine=[];
    timeLine= [
      ...timeLine,
      ...item.actionColis.map(ite=>(
        {
          title: ite.actNom,
          cardTitle: ite.actNom,
          cardSubtitle: ite.actUser.usNom,
          cardDetailedText: moment(ite.actCreate).format("DD-MM-YYYY HH:mm:SS")
        }
      ))
    ]
    console.log(timeLine);
    return (
        <Row>
          <Col xl="7">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
                <Table id="tech-companies-1" className="table table-striped table-bordered">
                  <Tbody>
                    <Tr><Td>Agence départ</Td><Td><strong>{item.opAgexp.agNom}</strong></Td></Tr>
                    <Tr><Td>Agence Bénéficiaire</Td><Td><strong>{item.opAgdest.agNom}</strong></Td></Tr>
                    <Tr><Td>Expéditeur</Td><Td><strong>{item.opExp} ({item.opPhonexp})</strong></Td></Tr>
                    <Tr><Td>Bénéficiaire</Td><Td><strong>{item.opDest} ({item.opDestphone})</strong></Td></Tr>
                    <Tr><Td>Code du colis</Td><Td><strong>{item.opCode}</strong></Td></Tr>
                    <Tr><Td>Emballage</Td><Td><strong>{item.detail[0].opdEmbal.embalLibelle}</strong></Td></Tr>
                    <Tr><Td>Nature</Td><Td><strong>{item.detail[0].opdNature.natLibelle}</strong></Td></Tr>
                    <Tr><Td>Valeur</Td><Td><strong>{item.opValeur} FCFA</strong></Td></Tr>
                    <Tr><Td>Frais</Td><Td><strong>{item.opFrais} FCFA</strong></Td></Tr>
                  </Tbody>
                </Table>
              </div>
            </div>
          </Col>
          <Col xl="5" style={{ height: "500px", overflow: "auto" }}>
            <Chrono disableToolbar={true} mode="VERTICAL_ALTERNATING" cardHeight={80} fontSizes={{ title: "9pt", cardTitle: "9pt", cardSubtitle: "7pt", cardDetailedText: "5pt"}} cardWidth={180} items={timeLine} />
          </Col>
          <Col xl="6" style={{ height: "500px", overflow: "auto" }}>
            {item.opImgret ? (<img style={{width: "80%"}} src={url.BACKEND_URL+"/file/"+item.opImgret} />): null}
          </Col>
          <Col xl="6" style={{ height: "500px", overflow: "auto" }}>
            {item.opImgcolis ? (<img style={{width: "80%"}} src={url.BACKEND_URL+"/file/"+item.opImgcolis} />): null}
          </Col>
        </Row>);};
  
  useEffect(() => {
    props.setBreadcrumbItems('Vos envois enregistrés')
    loadAgences()
    loadOperations(0)
  }, [])

  const verifData= ()=>{
    if (valeur==="" || valeur==='undefined' || valeur==null) { setMsgError("Valeur non définie"); return false;}
    else if (frais==="" || frais==='undefined' || frais==null) { setMsgError("Frais non défini"); return false;}
    else {return true; }
  }

  const verifDataDest= ()=>{
    if (newDest==="" || newDest==='undefined' || newDest==null) { setMsgError("Destination non définie"); return false;}
    else {return true; }
  }
  
  return (
    <React.Fragment>
      <Modal size="xl" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Consultation détails colis</h5>
        </div>
          {detail && getOperation(detail)}
      </Modal>
      <Modal size="md" isOpen={modal_del_opera} toggle={() => { tog_del_opera() }}>
        <div className="modal-header center">
          <h2 className="modal-title mt-0 center">Confirmez-vous la suppression du colis {detail?.opCode}?</h2>
        </div>
        <Row>
          <Col md="6">
            <Button style={{ width: "100%" }} className="btn btn-lg btn-primary" tag="button" onClick={()=>{tog_del_opera()}}>ANNULER</Button>
          </Col>
          <Col md="6">
            <Button style={{ width: "100%" }} className="btn btn-lg btn-danger" tag="button" onClick={()=>{deleteOperation()}}>CONFIRMER</Button>
          </Col>
        </Row>
      </Modal>
      <Modal size="md" isOpen={modal_set_opera} toggle={() => { tog_set_opera() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Modification Tarif du colis {detail?.opCode}</h5>
        </div>
        <div className="modal-body">
          <Row>
            <Col xl="6">
              <FormGroup className="mb-4">
                <div className="mb-3">
                  <label className="form-label" htmlFor="formrow-firstname-input">Valeur</label>
                  <input type="number" className="form-control" style={{ fontSize: "16pt" }} value={valeur} onChange={(event)=>setValeur(event.target.value)} id="exp" placeholder="Valeur du colis"/>
                </div>
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup className="mb-4">
                <div className="mb-3">
                  <label className="form-label" htmlFor="formrow-firstname-input">Frais</label>
                  <input type="number" className="form-control" style={{ fontSize: "16pt" }} value={frais} onChange={(event)=>setFrais(event.target.value)} id="exp" placeholder="Frais d'envoi"/>
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xl="12">
              <strong style={{ fontSize: 16, color:"rgb(236, 83, 108)"}}>{msgError}</strong>
              <strong style={{ fontSize: 16, color: "#02a499" }}>{msgSuccess}</strong>
            </Col>
          </Row>
          <Col xl="12">
            <Button style={{ width: "100%" }} className="btn btn-lg btn-primary" tag="button" onClick={()=>{updateOperationPrice()}}>
              MODIFIER LES FRAIS
            </Button>
          </Col>
        </div>
      </Modal>
      
      <Modal size="md" isOpen={modal_change_dest} toggle={() => { tog_change_dest() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Modification de la destination du colis {detail?.opCode}</h5>
        </div>
        <div className="modal-body">
          <Row>
            <Col xl="12">
              <FormGroup className="mb-4">
                <div className="mb-3">
                  <label className="form-label" htmlFor="formrow-firstname-input">Ancienne Destination</label>
                  <input type="text" className="form-control" style={{ fontSize: "16pt" }} value={detail?.opAgdest?.agNom} readOnly/>
                </div>
              </FormGroup>
            </Col>
            <Col lg="12">
              <div className="mb-3">
                <Label>Nouvelle Destination</Label>
                <Select
                  value={selectedNewDest}
                  onChange={handleNewDestination}
                  options={optionGroup}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl="12">
              <strong style={{ fontSize: 16, color:"rgb(236, 83, 108)"}}>{msgError}</strong>
              <strong style={{ fontSize: 16, color: "#02a499" }}>{msgSuccess}</strong>
            </Col>
          </Row>
          <Col xl="12">
            <Button style={{ width: "100%" }} className="btn btn-lg btn-primary" tag="button" onClick={()=>{changeDestination()}}>
              MODIFIER LA DESTINATION
            </Button>
          </Col>
        </div>
      </Modal>
        
      <Row>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="2">
          <div className="mb-3">
            <Label>Départ</Label>
            <Select
              value={selectedDep}
              onChange={handleDepart}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mb-3">
            <Label>Destination</Label>
            <Select
              value={selectedDest}
              onChange={handleDestination}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mb-3">
            <Label>Status</Label>
            <Select
              value={selectedStatus}
              onChange={handleStatus}
              options={optionStatus}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-3">
            <div className="mb-0">
              <label className="form-label" htmlFor="formrow-firstname-input">Numéro colis</label>
              <input type="text" className="form-control" value={numColis} onChange={(event)=>setNumColis(event.target.value)} id="exp" placeholder="Numéro du colis"/>
            </div>
          </FormGroup>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-3">
            <div className="mb-0">
              <label className="form-label" htmlFor="formrow-firstname-input">Numéro expéditeur</label>
              <input type="text" className="form-control" value={numExp} onChange={(event)=>setNumExp(event.target.value)} id="exp" placeholder="Numéro expéditeur"/>
            </div>
          </FormGroup>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-3">
            <div className="mb-0">
              <label className="form-label" htmlFor="formrow-firstname-input">Numéro Bénéficiaire</label>
              <input type="text" className="form-control" value={numBenef} onChange={(event)=>setNumBenef(event.target.value)} id="exp" placeholder="Numéro du bénéficiaire"/>
            </div>
          </FormGroup>
        </Col>
         <Col lg="2">
          <div className="mb-3">
            <Label>Type colis</Label>
            <Select
              value={selectedType}
              onChange={handleType}
              options={optionType}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
         <Col lg="2">
          <div className="mb-3">
            <Label>Type retrait</Label>
            <Select
              value={selectedTypeRetrait}
              onChange={handleTypeRetrait}
              options={optionTypeRetrait}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadOperations(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Recharger</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalOps} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadOperations(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadOperations(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingOps ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                    style={{fontSize: 10}}
                  >
                    <Thead>
                      <Tr>
                        <Th>Origine</Th>
                        <Th>Destination</Th>
                        <Th data-priority="1">Code</Th>
                        <Th data-priority="3">Date heure</Th>
                        <Th data-priority="3">Expéditeur</Th>
                        <Th data-priority="1">Bénéficiaire</Th>
                        <Th data-priority="3">Frais</Th>
                        <Th data-priority="3">Etat</Th>
                        <Th data-priority="6">Détail</Th>
                        <Th colspan="3">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {operations.map((item, key)=>(
                      <Tr>
                        <Th><strong style={{ fontSize: 10 }}>{item.opAgexp.agNom}</strong></Th>
                        <Th><strong style={{ fontSize: 10 }}>{item.opAgdest.agNom}</strong></Th>
                        <Td>{item.opCode}</Td>
                        <Td>{moment(item.opCreate).format("DD-MM-YY HH:mm:ss")}</Td>
                        <Td>{item.opExp} ({item.opPhonexp})</Td>
                        <Td>{item.opDest} {item.opPickupWithoutDoc ? null: (<i className="fa fa-address-card"></i>)} <br/>({item.opDestphone})</Td>
                        <Td>{item.opFrais} FCFA</Td>
                        <Td>
                          {
                          item.opStat.etatLibelle=="EN ATTENTE" ?  <strong style={{ fontSize: 7 }} className="btn btn-danger">{item.opStat.etatLibelle}</strong> :
                          item.opStat.etatLibelle=="EN TRANSIT" ? <strong style={{ fontSize: 7 }} className="btn btn-warning">{item.opStat.etatLibelle}</strong> :
                          item.opStat.etatLibelle=="ARRIVE A DESTINATION" ? <strong style={{ fontSize: 7 }} className="btn btn-info">{item.opStat.etatLibelle}</strong> :
                          item.opStat.etatLibelle=="COLIS LIVRE" ? <strong style={{ fontSize: 7 }} className="btn btn-success">{item.opStat.etatLibelle}</strong> : null
                          }
                         
                        </Td>
                        <Td><Button onClick={()=>{setDetail(item); setTimeout(() => { tog_get_opera() }, 100);}} ><i className="fa fa-eye"></i></Button></Td>
                        <Td><Button className= "btn btn-warning" onClick={()=>{setDetail(item); setValeur(item.opValeur); setFrais(item.opFrais); setTimeout(() => { tog_set_opera() }, 100);}} ><i className="fa fa-money-bill"></i></Button></Td>
                        <Td><Button className= "btn btn-primary" onClick={()=>{setDetail(item); setTimeout(() => { tog_change_dest() }, 100);}} ><i className="ion ion-ios-swap"></i></Button></Td>
                        <Td><Button className= "btn btn-danger" onClick={()=>{setDetail(item); setTimeout(() => { tog_del_opera() }, 100);}} ><i className="fa fa-times"></i></Button></Td>
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Operations)